import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Backdrop,
  CircularProgress,
  Snackbar,
  Checkbox,
} from "@material-ui/core";
import { makeStyles, styled } from "@material-ui/core/styles";
import axios from "axios";
import { API_HOST, API_ROOT } from "./utils/api-config";
import MuiAlert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
    },
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ContactUs(props) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessages, setErrorMessages] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [state, setState] = React.useState({
    contactMile1: true,
    contactMerchant: false,
  });
  const [value, setValue] = React.useState(
    props.email ? "email" : props.phone ? "text" : ""
  );
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);

  useEffect(() => {
    setEmail(props.email);
    setName(props.name);
    setPhone(props.phone);
    setSubject(
      props.merchant
        ? props.pickup
          ? `Return to ${props.merchant}`
          : `Delivery from ${props.merchant}`
        : ""
    );
    setMessage("");
    setValue(props.email ? "email" : "text");
    setErrorMessages([]);
    setShowErrors(false);
    window.history.pushState({}, null, "/contact");
  }, [props]);

  useEffect(() => {
    return () => {
      setEmail("");
      setName("");
      setPhone("");
      setSubject("");
      setMessage("");
      setValue("");
      setErrorMessages([]);
      setShowErrors(false);
      // props.history.push("/component/dummy-string");
    };
  }, []);

  const handleContactChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const MyButton = styled(Button)({
    background: "#B8D5B6",
    border: 0,
    borderRadius: 3,
    color: "white",
    height: 48,
    padding: "0 30px",
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen1(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  let errors = [];
  // function ValidateEmail(email) {
  //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
  //     return true;
  //   }
  //   return false;
  // }

  const formValidation = (e) => {
    e.preventDefault();
    handleToggle();
    setErrorMessages([]);
    setDisabled(true);
    const isNameValid = name !== "";
    const isMessageValid = message !== "";
    const isSubjectValid = subject !== "";

    if (!isNameValid) {
      errors.push("Name is not valid, please try again.");
    }
    // if (!ValidateEmail(email)) {
    //   errors.push("Email is not valid, please try again.");
    // }
    if (email === "") {
      errors.push("Email field is empty, please try again.");
    }
    if (!isMessageValid) {
      errors.push("Message is not valid, please try again.");
    }
    if (!isSubjectValid) {
      errors.push("Subject is not valid, please try again.");
    }
    if (errors.length > 0) {
      setShowErrors({ showErrors: true });
      setErrorMessages(errors);
    } else {
      const formData = {
        inquery: {
          name: name,
          email: email,
          company: props.merchant,
          phone: phone,
          preferred: value,
          message: message,
          [props.type]: props.id,
          contact_mile1: state.contactMile1,
          contact_merchant: state.contactMerchant,
        },
      };
      setShowErrors({ showErrors: false });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios
        .post(`${API_ROOT}/inqueries/`, formData, config)
        .then(({ data }) => {
          if (data == "Your message has been sent") {
            alert(data), window.location.replace("https://mile1.ca/");
          } else handleClose(), setOpen1(true), setDisabled(false);
        })
        .catch((error) => alert(error));
    }
  };

  return (
    <div className="container">
      <div className="outerFormContainer">
        <div className="innerFormContainer">
          <h2> Contact Us</h2>
          <h4>
            If you need to reschedule the delivery press here:{" "}
            <Button>
              <a
                href={`${API_HOST}/${props.pickup ? "pickup" : "book"}?f=${
                  props.history.location.pathname.split("/")[2]
                }&commit=reschedule`}
              >
                Reschedule
              </a>
            </Button>{" "}
          </h4>

          <form className={classes.root}>
            {Boolean(props.customer_support_email) && (
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.contactMile1}
                      onChange={handleContactChange}
                      name="contactMile1"
                      color="secondary"
                    />
                  }
                  label="Contact Mile1 regarding delivery"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.contactMerchant}
                      onChange={handleContactChange}
                      name="contactMerchant"
                      color="primary"
                    />
                  }
                  label={`Email ${props.merchant} regarding your order`}
                />
              </FormGroup>
            )}
            <TextField
              label="Name"
              value={name}
              variant="outlined"
              type="text"
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              label="Subject"
              value={subject}
              variant="outlined"
              type="text"
              onChange={(e) => setSubject(e.target.value)}
            />
            <TextField
              label="Message"
              placeholder="How we can help you?"
              type="text"
              variant="outlined"
              multiline
              rows="5"
              onChange={(e) => {
                setMessage(e.target.value), setDisabled(false);
              }}
            />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                <h4>What's the best way to contact you?</h4>
              </FormLabel>
              <RadioGroup
                aria-label="contact"
                name="contact1"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="email"
                  control={<Radio />}
                  label="Email"
                />
                {value == "email" && (
                  <TextField
                    label="Email"
                    value={email}
                    type="email"
                    variant={email ? "filled" : "outlined"}
                    // variant="outlined"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                )}
                <FormControlLabel
                  value="text"
                  control={<Radio />}
                  label="Text"
                />
                {(value == "call" || value == "text") && (
                  <TextField
                    label="Phone"
                    value={phone}
                    type="text"
                    variant={phone ? "filled" : "outlined"}
                    multiline
                    rowsMax="3"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                )}
                <FormControlLabel
                  value="call"
                  control={<Radio />}
                  label="Call"
                />
              </RadioGroup>
            </FormControl>
            {showErrors
              ? errorMessages.map((item, index) => {
                  return <ul key={index}>{item}</ul>;
                })
              : null}
            <MyButton disabled={disabled} onClick={formValidation}>
              Send
            </MyButton>
            <Backdrop
              className={classes.backdrop}
              open={open}
              onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
              open={open1}
              autoHideDuration={6000}
              onClose={handleClose1}
            >
              <Alert onClose={handleClose1} severity="warning">
                We were not able to send your message. Please try again.
              </Alert>
            </Snackbar>
          </form>
        </div>
      </div>
    </div>
  );
}
export default ContactUs;
